export default __webpack_public_path__ + "images/EO.4bbef1a.png";